const fieldNames: fieldNamesInterface = {
  customerNumber: 'customerNumber',
  phoneNumber: 'phoneNumber',
  name: 'name',
  street: 'street',
  houseNumber: 'houseNumber',
  plz: 'plz',
  city: 'city',
  clientComment: 'clientComment',
  deliveryCost: 'deliveryCost',
  article: 'article',
  quantity: 'quantity',
  productName: 'productName',
  price: 'price'
};

export interface fieldNamesInterface {
  customerNumber: string,
  phoneNumber: string,
  name: string,
  street: string,
  houseNumber: string,
  plz: string,
  city: string,
  clientComment: string,
  deliveryCost: string,
  article: string;
  quantity: string;
  productName: string;
  price: string;
};

export default fieldNames;
